import { useSelector } from 'react-redux';

import { getUserABTestVariants } from 'state/user/selectors';

export const useABTestVariants = () => {
  return useSelector(getUserABTestVariants);
};
